import type { ReactNode } from 'react'
import { AppleChar, type AppleCharMood } from './AppleChar'

export interface EmptyStateProps {
  mood?: AppleCharMood
  title: string
  subtitle?: string
  action?: ReactNode
}

export function EmptyState({
  mood = 'sleepy',
  title,
  subtitle,
  action,
}: EmptyStateProps) {
  return (
    <div className="empty">
      <AppleChar size={80} mood={mood} />
      <p className="empty__title">{title}</p>
      {subtitle != null && <p className="empty__sub">{subtitle}</p>}
      {action != null && action}
    </div>
  )
}
